import React from 'react';

import AnnotationModeBanner from 'client/AssignmentPracticeView/StudentPracticeViewToolbar/AnnotationModeBanner.react';
import {useIsSubjectPracticeAnnotationAvailable} from 'client/SubjectPracticeView/useIsSubjectPracticeAnnotationAvailable';

export default function SubjectAnnotationModeBanner() {
  const isAvailable = useIsSubjectPracticeAnnotationAvailable();

  if (!isAvailable) {
    return null;
  }

  return <AnnotationModeBanner />;
}
